import { ClientExtendInfo } from "./ClientExtendInfo/ClientExtendInfo";
import ClientInfo from "./ClientInfo/ClientInfo";


export const SingleClient = {
    Info: ClientInfo,
    InfoExtend: ClientExtendInfo
}

export default SingleClient;